import React from "react";
import FeatureCardItem from './FeatureCardItem';
import {Constants} from "../constants/Constants";

const FullFeaturesList = React.forwardRef(function (props: any, ref: any) {
    return (
        <div
            ref={ref}
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                backgroundColor: '#f6efe8',
            }}>
            <FeatureCardItem title={"Win"} imageSrc={require("../images/bitcoin_for_all.png")}
                             description={`Try your luck every hour for a chance to win up to <b style='color:black;'>$200</b> in free bitcoins!`}/>
            <FeatureCardItem title={"Multiply"} imageSrc={require("../images/free_bitcoin.png")}
                             description={`Easily multiply your bitcoins by up to <b style='color:black;'>4,750</b> times playing our simple <b>${Constants.MULTIPLY_BTC_GAME}</b> Game that has being designed to be <b>provably fair</b>.`}/>
        </div>
    )
});

export default FullFeaturesList;
